import { DateFacetFilterItem, RangeValue } from "./date-facet-filter.types";
import { MDSDateRangePicker } from "@/mds";
import styled from "@emotion/styled";
import { ListBoxItem } from "react-aria-components";

interface DateFacetFilterDateRangePickerProps {
  item: DateFacetFilterItem;
  value: RangeValue | null;
}

export const DateFacetFilterDateRangePicker = ({
  item,
  value,
}: DateFacetFilterDateRangePickerProps) => {
  return (
    <StyledWrapper data-mds-name="date-facet-custom-range-item" textValue={item.title}>
      <MDSDateRangePicker
        label={item.title}
        value={value}
        onChange={range => {
          item.onSelect({
            type: item.type,
            from: range?.start || undefined,
            to: range?.end || undefined,
          });
        }}
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled(ListBoxItem)`
  grid-column: 1 / -1;
  min-width: 0;
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
`;
